import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ViewerManagerFontsApi } from './viewerManagerFontsApi'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { FontLoadStatus } from './fontsLoadStatus'
import { FontsLoadingState } from './fontsLoadingState'
import { FontsLoadingStateSymbol, FontsStatusNotifierSymbol } from './symbols'
import { DataRequirementsCheckerSymbol } from '@wix/thunderbolt-symbols'
import { FontsStatusNotifier } from './fontsStatusNotifier'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ViewerManagerApiImplementor).to(ViewerManagerFontsApi)
	bind(FontsLoadingStateSymbol).to(FontsLoadingState)
	bind(ModelUpdatesHandlersImplementor, DataRequirementsCheckerSymbol).to(FontLoadStatus)
	bind(FontsStatusNotifierSymbol).to(FontsStatusNotifier)
}

export { FontsStatusNotifierSymbol }
export type { IFontsStatusNotifier } from './types'
